import { IBFRecordParsingDefinition } from "@/lib/drivers/insulet/IBFRecords/RecordParser";

type IBFManufacturingNumber = {
  manufacturingNumber: string;
};

export const IBF_MANUFACTURING_NUMBER = {
  // Value is just the order in which the items are present in the file
  value: 3,
  name: "IBF_MANUFACTURING_NUMBER",
  size: 1,
  parse: record => {
    const manufacturingNumber = record.nextString();
    return {
      manufacturingNumber,
    };
  },
} satisfies IBFRecordParsingDefinition<IBFManufacturingNumber>;
